(function () {
  function init(section) {
    if (section.dataset.pdpInit === '1') return;
    section.dataset.pdpInit = '1';

    var form = section.querySelector('.sannico-pdp__form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var cta = form.querySelector('.sannico-pdp__cta');
    var optGroups = form.querySelectorAll('[data-opt]');

    var variants = [];
    var dataTag = section.querySelector('[data-pdp-variants]');
    if (dataTag) {
      try { variants = JSON.parse(dataTag.textContent); } catch (e) { variants = []; }
    }
    // Much of the migrated catalog does not track stock, so sold out only counts when stock is tracked.
    var stockIsTracked = variants.some(function (v) { return v.tracked; });
    var addLabel = (cta && cta.dataset.addLabel) ? cta.dataset.addLabel : 'Add to cart';
    var isB2B = section.classList.contains('sannico-pdp--b2b');
    var priceAmount = section.querySelector('[data-price-amount]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var saleBadge = section.querySelector('.sannico-pdp__stage-badge--sale');

    function chosenValues() {
      var chosen = [];
      optGroups.forEach(function (g) {
        var on = g.querySelector('[data-opt-btn].is-on');
        chosen.push(on ? on.dataset.optValue : '');
      });
      return chosen;
    }

    function matchVariant(values) {
      return variants.find(function (v) {
        return v.options.length === values.length && v.options.every(function (o, i) { return o === values[i]; });
      });
    }

    // Strike a chip only when no variant has it or all of them are sold out. Options can be linked
    // (Junior and Men's never share a size), so checking other groups' picks would strike a whole group.
    function refreshAvailability() {
      optGroups.forEach(function (g, gi) {
        g.querySelectorAll('[data-opt-btn]').forEach(function (btn) {
          if (btn.classList.contains('is-on')) { btn.classList.remove('is-out'); btn.removeAttribute('aria-disabled'); return; }
          var value = btn.dataset.optValue;
          var reachable = variants.filter(function (v) { return v.options[gi] === value; });
          var out = reachable.length ? (stockIsTracked && !reachable.some(function (v) { return v.available; })) : true;
          btn.classList.toggle('is-out', out);
          if (out) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
        });
      });
    }

    function syncVisibility() {
      var values = chosenValues();
      optGroups.forEach(function (g, gi) {
        if (gi === 0) return;
        g.querySelectorAll('[data-opt-btn]').forEach(function (btn) {
          var value = btn.dataset.optValue;
          var fits = variants.some(function (v) {
            for (var j = 0; j < gi; j++) { if (v.options[j] !== values[j]) return false; }
            return v.options[gi] === value;
          });
          btn.hidden = !fits;
        });
      });
    }

    var priceAddons = section.querySelector('[data-price-addons]');
    var lastMatch = null;
    var bundleExtraCents = null;
    var bundleTotalCents = null;
    var optionalCents = null;
    var priceTotal = section.querySelector('[data-price-total]');
    function money(cents) {
      var fmt = (priceAddons && priceAddons.dataset.moneyFormat) || '${{amount}}';
      var n = cents / 100;
      var withComma = function (v) { return v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      return fmt
        .replace('{{amount_no_decimals_with_comma_separator}}', withComma(String(Math.round(n))))
        .replace('{{amount_with_comma_separator}}', withComma(n.toFixed(2)).replace('.', ','))
        .replace('{{amount_no_decimals}}', withComma(String(Math.round(n))))
        .replace('{{amount}}', withComma(n.toFixed(2)));
    }
    function chosenAddons() {
      var out = [];
      section.querySelectorAll('[data-addon]').forEach(function (a) {
        var toggle = a.querySelector('[data-addon-toggle]');
        var input = a.querySelector('[data-addon-input]');
        if (!toggle || !toggle.checked || !input || !input.value.trim()) return;
        out.push({ label: a.dataset.addonLabel || a.dataset.addonKey, price: parseInt(a.dataset.addonPrice, 10) || 0 });
      });
      return out;
    }
    function updatePrice(match) {
      if (match) lastMatch = match; else match = lastMatch;
      if (!match) return;
      var extras = priceAddons ? chosenAddons() : [];
      var extra = extras.reduce(function (n, a) { return n + a.price; }, 0) + (bundleExtraCents ? bundleExtraCents() : 0);
      if (priceAmount) {
        if (extra && typeof match.price === 'number') priceAmount.textContent = money(match.price + extra);
        else if (match.price_money) priceAmount.textContent = match.price_money;
      }
      if (priceAddons) {
        priceAddons.hidden = !extra;
        var base = priceAddons.querySelector('[data-price-base]');
        var list = priceAddons.querySelector('[data-price-addon-list]');
        if (base) base.textContent = match.price_money || '';
        if (list) list.textContent = extras.map(function (a) { return a.label + ' ' + money(a.price); }).join(' + ');
      }
      if (priceCompare && !isB2B) {
        if (match.on_sale && match.compare_money) { priceCompare.textContent = match.compare_money; priceCompare.hidden = false; }
        else priceCompare.hidden = true;
      }
      if (saleBadge) {
        if (match.on_sale && match.compare_money) {
          var off = Math.round((1 - (match.price / parseMoney(match.compare_money))) * 100);
          saleBadge.textContent = off > 0 ? '-' + off + '%' : saleBadge.textContent;
          saleBadge.hidden = false;
        } else { saleBadge.hidden = true; }
      }
      updateTotal();
    }
    // The price above is for one package; this line adds them all up, extra prints included.
    function updateTotal() {
      if (!priceTotal || !lastMatch || typeof lastMatch.price !== 'number') return;
      var n = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var optional = optionalCents ? optionalCents() : 0;
      if (n < 2 && !optional) { priceTotal.hidden = true; return; }
      var cents = n * lastMatch.price + (bundleTotalCents ? bundleTotalCents(n) : 0) + optional;
      var parts = ((optional ? priceTotal.dataset.labelOptional : priceTotal.dataset.label) || '').replace('[count]', n).split('[total]');
      var amount = document.createElement('strong');
      amount.textContent = money(cents);
      priceTotal.textContent = parts[0];
      priceTotal.appendChild(amount);
      if (parts[1]) priceTotal.appendChild(document.createTextNode(parts[1]));
      priceTotal.hidden = false;
    }
    function parseMoney(s) { return parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0; }

    function resolveVariant(anchorGi, anchorValue) {
      if (!variants.length) return;
      var match = optGroups.length ? matchVariant(chosenValues()) : variants[0];
      // No exact match: a linked group still holds an old value, so keep the value just picked and sync the rest.
      if (!match && typeof anchorGi === 'number') {
        match = variants.find(function (v) { return v.options[anchorGi] === anchorValue; });
        if (match) {
          optGroups.forEach(function (g, gi) {
            if (gi === anchorGi) return;
            var val = match.options[gi];
            g.querySelectorAll('[data-opt-btn]').forEach(function (b) {
              var on = b.dataset.optValue === val;
              b.classList.toggle('is-on', on);
              b.setAttribute('aria-checked', on ? 'true' : 'false');
              b.tabIndex = on ? 0 : -1;
            });
            var cur = g.querySelector('[data-opt-current]');
            if (cur) cur.textContent = val;
          });
        }
      }
      if (!match) {
        if (idInput) idInput.value = '';
        if (cta) { cta.disabled = true; cta.textContent = 'Unavailable'; }
        refreshAvailability();
        syncVisibility();
        return;
      }
      idInput.value = match.id;
      if (qtyInput) {
        qtyInput.min = match.min;
        qtyInput.step = match.increment;
        if (parseInt(qtyInput.value, 10) < match.min) qtyInput.value = match.min;
      }
      if (cta) {
        var sellable = match.available || !stockIsTracked;
        cta.disabled = !sellable;
        cta.textContent = sellable ? addLabel : 'Sold out';
      }
      updatePrice(match);
      refreshAvailability();
      syncVisibility();
    }

    // A radio group is one tab stop. Arrow keys move inside it.
    function selectOption(g, btn, moveFocus, gi) {
      if (!btn || btn.classList.contains('is-out')) return;
      g.querySelectorAll('[data-opt-btn]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      var cur = g.querySelector('[data-opt-current]');
      if (cur) cur.textContent = btn.dataset.optValue;
      if (moveFocus) btn.focus();
      resolveVariant(gi, btn.dataset.optValue);
    }

    optGroups.forEach(function (g, gi) {
      var buttons = Array.prototype.slice.call(g.querySelectorAll('[data-opt-btn]'));
      buttons.forEach(function (b) {
        b.tabIndex = b.classList.contains('is-on') ? 0 : -1;
      });
      if (buttons.length && !g.querySelector('[data-opt-btn].is-on')) buttons[0].tabIndex = 0;

      g.addEventListener('click', function (e) {
        selectOption(g, e.target.closest('[data-opt-btn]'), false, gi);
      });

      g.addEventListener('keydown', function (e) {
        var btn = e.target.closest('[data-opt-btn]');
        if (!btn) return;
        var idx = buttons.indexOf(btn);
        var to = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (idx + 1) % buttons.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (idx - 1 + buttons.length) % buttons.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = buttons.length - 1;
        else return;
        e.preventDefault();
        selectOption(g, buttons[to], true, gi);
      });
    });
    // Junior sizes come from a separate product, so the server cannot open on their ?variant= id.
    var asked = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    if (asked && idInput && String(idInput.value) !== String(asked)) {
      var wanted = variants.find(function (v) { return v.id === asked; });
      if (wanted) {
        optGroups.forEach(function (g, gi) {
          g.querySelectorAll('[data-opt-btn]').forEach(function (b) {
            var on = b.dataset.optValue === wanted.options[gi];
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
          });
          var cur = g.querySelector('[data-opt-current]');
          if (cur) cur.textContent = wanted.options[gi];
        });
      }
    }
    resolveVariant();

    var mainImg = section.querySelector('[data-pdp-main]');
    var thumbs = section.querySelectorAll('[data-pdp-thumb]');
    if (mainImg && thumbs.length) {
      var swapTo = function (t) {
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
        var st = section.querySelector('[data-pdp-stage]');
        if (st) st.classList.remove('is-zooming');
        if (t.dataset.srcset) mainImg.srcset = t.dataset.srcset;
        if (t.dataset.full) mainImg.src = t.dataset.full;
      };
      thumbs.forEach(function (t) {
        // pointerdown swaps immediately so a single press registers, even while hovering the stage
        t.addEventListener('pointerdown', function (e) { e.preventDefault(); swapTo(t); });
        t.addEventListener('click', function (e) { e.preventDefault(); swapTo(t); });
      });
    }
    var stage = section.querySelector('[data-pdp-stage]');
    if (stage && mainImg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var coarse = window.matchMedia('(hover: none)').matches;
      if (!coarse) {
        stage.addEventListener('mousemove', function (e) {
          if (e.target.closest('.sannico-pdp__thumbs') || e.target.closest('.sannico-pdp__zoom-hint')) {
            stage.classList.remove('is-zooming');
            return;
          }
          stage.classList.add('is-zooming');
          var r = stage.getBoundingClientRect();
          stage.style.setProperty('--zx', (((e.clientX - r.left) / r.width) * 100) + '%');
          stage.style.setProperty('--zy', (((e.clientY - r.top) / r.height) * 100) + '%');
        });
        stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zooming'); });
      }
    }

    function clampQty(commit) {
      if (!qtyInput) return 1;
      var step = parseInt(qtyInput.step, 10) || 1;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < min) val = min;
      if (step > 1) val = min + Math.round((val - min) / step) * step;
      if (max && val > max) val = max;
      if (commit) qtyInput.value = val;
      return val;
    }
    var volChart = section.querySelector('[data-volume-chart]');
    var volRows = volChart ? volChart.querySelectorAll('[data-tier-min]') : [];
    var volActiveLabel = volChart ? (volChart.getAttribute('data-active-label') || '') : '';
    function markActiveTier(qty) {
      var winner = null;
      volRows.forEach(function (row) {
        var min = parseInt(row.getAttribute('data-tier-min'), 10);
        if (!isNaN(min) && qty >= min) winner = row;
      });
      volRows.forEach(function (row) {
        if (row === winner) {
          row.setAttribute('data-tier-active', '');
          var cell = row.querySelector('td');
          if (cell && volActiveLabel) cell.setAttribute('data-active-label', volActiveLabel);
        } else {
          row.removeAttribute('data-tier-active');
        }
      });
    }

    var stepper = section.querySelector('[data-pdp-stepper]');
    if (stepper && qtyInput) {
      stepper.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(qtyInput.step, 10) || 1;
          qtyInput.value = (parseInt(qtyInput.value, 10) || parseInt(qtyInput.min, 10) || 1) + parseInt(b.dataset.step, 10) * step;
          markActiveTier(clampQty(true));
          qtyInput.dispatchEvent(new CustomEvent('pdp:qty'));
        });
      });
      qtyInput.addEventListener('input', function () { markActiveTier(parseInt(qtyInput.value, 10) || 0); });
      qtyInput.addEventListener('change', function () { markActiveTier(clampQty(true)); qtyInput.dispatchEvent(new CustomEvent('pdp:qty')); });
      qtyInput.addEventListener('blur', function () { markActiveTier(clampQty(true)); });
    }
    if (volRows.length) markActiveTier(qtyInput ? clampQty(false) : 1);

    var addons = section.querySelectorAll('[data-addon]');
    var preview = section.querySelector('[data-pdp-preview]');
    var previewName = section.querySelector('[data-preview-name]');
    var previewNumber = section.querySelector('[data-preview-number]');
    var previewImg = section.querySelector('[data-preview-img]');
    var backImages = null;
    if (preview && preview.dataset.backImages) {
      try { backImages = JSON.parse(preview.dataset.backImages); } catch (e) { backImages = null; }
    }

    function sanitize(input) {
      if (!input) return;
      var out = input.value;
      if (input.dataset.preview === 'number') {
        var max = parseInt(input.getAttribute('max'), 10);
        if (isNaN(max)) max = 99;
        out = input.value.replace(/\D/g, '').slice(0, String(max).length);
        if (out !== '' && parseInt(out, 10) > max) out = String(max);
      } else if (input.dataset.sanitize === 'text') {
        out = input.value.replace(/[^\p{L}\s'-]/gu, '');
      }
      if (out !== input.value) input.value = out;
    }

    function backShotForColour() {
      if (!backImages) return null;
      var hit = null;
      optGroups.forEach(function (g) {
        if (hit || !/colou?r|couleur/i.test(g.dataset.optName || '')) return;
        var on = g.querySelector('[data-opt-btn].is-on');
        if (on && backImages[on.dataset.optValue]) hit = backImages[on.dataset.optValue];
      });
      return hit;
    }

    function fitPrint(node) {
      node.style.letterSpacing = '';
      node.style.transform = '';
      var max = node.parentNode.getBoundingClientRect().width * 0.40;
      if (!max) return;
      var w = node.getBoundingClientRect().width;
      if (w <= max) return;
      node.style.letterSpacing = '0.04em';
      w = node.getBoundingClientRect().width;
      if (w <= max) return;
      node.style.transform = 'translateX(-50%) scaleX(' + (max / w).toFixed(3) + ')';
    }

    function refreshPreview() {
      if (!preview) return;
      var name = '', number = '';
      addons.forEach(function (a) {
        var toggle = a.querySelector('[data-addon-toggle]');
        var input = a.querySelector('[data-addon-input]');
        if (!toggle || !toggle.checked || !input) return;
        if (input.dataset.preview === 'name') name = input.value.toUpperCase();
        if (input.dataset.preview === 'number') number = input.value;
      });
      if (previewName) { previewName.textContent = name; fitPrint(previewName); }
      if (previewNumber) { previewNumber.textContent = number; fitPrint(previewNumber); }
      if (previewImg) {
        var back = backShotForColour();
        var want = back || previewImg.dataset.front;
        if (want && previewImg.getAttribute('src') !== want) previewImg.src = want;
      }
      preview.hidden = !(name || number);
    }
    function refreshAddons() { refreshPreview(); updatePrice(); }

    addons.forEach(function (a) {
      var toggle = a.querySelector('[data-addon-toggle]');
      var input = a.querySelector('[data-addon-input]');
      if (!toggle) return;
      toggle.addEventListener('change', function () {
        if (input) {
          input.hidden = !toggle.checked;
          if (toggle.checked) input.focus();
          else input.value = '';
        }
        refreshAddons();
      });
      if (input) input.addEventListener('input', function () { sanitize(input); refreshAddons(); });
    });
    if (preview) optGroups.forEach(function (g) { g.addEventListener('click', function () { setTimeout(refreshPreview, 0); }); });

    // Same property names as the bulk builder (sannico-order-lines.js), so the print shop reads one format.
    function inlineItems(baseId, qty) {
      var chosen = [];
      addons.forEach(function (a) {
        var toggle = a.querySelector('[data-addon-toggle]');
        var input = a.querySelector('[data-addon-input]');
        if (!toggle || !toggle.checked || !input) return;
        var value = input.value.trim();
        if (!value) return;
        chosen.push({ key: a.dataset.addonKey, variantId: parseInt(a.dataset.addonVariant, 10), value: value });
      });
      var byKey = {};
      chosen.forEach(function (c) { byKey[c.key] = c; });

      var base = { id: baseId, quantity: qty };
      if (byKey.name || byKey.number) {
        base.properties = { Players: (byKey.name ? byKey.name.value : '-') + (byKey.number ? ' #' + byKey.number.value : '') };
      }
      if (playerName && playerName.value.trim()) base.properties = Object.assign({}, base.properties || {}, { Name: cleanName(playerName.value) });
      if (playerNumber && playerNumber.value.trim()) base.properties = Object.assign({}, base.properties || {}, { Number: playerNumber.value.trim() });
      // Tells checkout what this page insisted on, so it can refuse the item if it ever arrives without it.
      if (!bundleSelects.length) {
        var asked = [];
        if (playerName && !playerName.hasAttribute('data-optional')) asked.push('name');
        if (playerNumber && !playerNumber.hasAttribute('data-optional')) asked.push('number');
        if (asked.length) base.properties = Object.assign({}, base.properties || {}, { _asks: asked.join(',') });
      }
      var team = (playerName || playerNumber) ? roster.teamOf(playerName ? playerName.value : '', playerNumber ? playerNumber.value : '') : '';
      if (team) base.properties = Object.assign({}, base.properties || {}, { Team: team });
      if (bundleSelects.length) return bundleLines(baseId);
      var items = [base];
      // A club can ask for the name and number on a single item: each is printed as its own line, at the club's price.
      [['printName', 'Name', playerName ? cleanName(playerName.value) : ''], ['printNumber', 'Number', playerNumber ? playerNumber.value.trim() : '']].forEach(function (p) {
        var id = parseInt(form.dataset[p[0]], 10);
        if (!id || !p[2]) return;
        var props = { 'Printed on': form.dataset.productTitle || '' };
        props[p[1]] = p[2];
        items.push({ id: id, quantity: qty, properties: props });
      });
      if (extrasBox && extrasNow().length) {
        items = items.concat(extraLines(base, extrasNow(), playerNumber ? playerNumber.value.trim() : extraNumber ? extraNumber.value.trim() : ''));
      }
      if (byKey.name) items.push({ id: byKey.name.variantId, quantity: qty, properties: { Names: byKey.name.value } });
      if (byKey.number) items.push({ id: byKey.number.variantId, quantity: qty, properties: { Numbers: byKey.number.value } });
      // A hidden property ties add-ons to their shirt. Underscore keys never show at checkout.
      if (items.length > 1) {
        var gid = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        items.forEach(function (it) { it.properties = Object.assign({ _group: gid }, it.properties || {}); });
      }
      return items;
    }

    // Guard on the form: section:load can run init() again, and two listeners would add everything twice.
    if (form.dataset.pdpSubmitBound === '1') return;
    form.dataset.pdpSubmitBound = '1';
    var bundle = form.querySelector('[data-pdp-bundle]');
    var bundleSelects = Array.prototype.slice.call(form.querySelectorAll('[data-bundle-size]'));
    var bundleError = form.querySelector('[data-bundle-error]');
    var bundleProgress = form.querySelector('[data-bundle-progress]');
    var bundleTabs = form.querySelector('[data-bundle-tabs]');
    var bundleList = form.querySelector('.sannico-pdp__bundle-list');
    var bundleRemove = form.querySelector('[data-bundle-remove]');
    var sameBox = form.querySelector('[data-bundle-same]');
    var sameRow = form.querySelector('[data-bundle-same-row]');
    var sameText = form.querySelector('[data-bundle-same-text]');
    var sameAll = true;
    var sets = [[]];
    var active = 0;
    var bundleNumber = form.querySelector('[data-bundle-number]');
    var numbers = [''];
    if (bundleNumber) sameAll = false;
    var bundleName = form.querySelector('[data-bundle-name]');
    var names = [''];
    if (bundleName) sameAll = false;
    var playerName = form.querySelector('[data-player-name]');
    var playerNameError = form.querySelector('[data-player-name-error]');
    var rosterMode = !!form.querySelector('[data-roster]');
    if (rosterMode) form.setAttribute('data-roster-mode', '');
    var NAME_MAX = rosterMode ? 40 : 12;
    function cleanName(v) { var n = String(v || '').replace(/\s+/g, ' ').trim(); return rosterMode ? n : n.toUpperCase(); }
    function validName(v) { var n = cleanName(v); return n.length > 0 && n.length <= NAME_MAX && /^[A-ZÀ-Ý' .-]+$/.test(n.toUpperCase()); }
    function lettersOnly(input) {
      input.addEventListener('input', function () {
        var clean = input.value.replace(/[^A-Za-zÀ-ÿ' .-]/g, '');
        clean = (rosterMode ? clean : clean.toUpperCase()).slice(0, NAME_MAX);
        if (clean !== input.value) input.value = clean;
        if (validName(input.value)) input.classList.remove('is-missing');
      });
    }
    if (playerName) {
      lettersOnly(playerName);
      playerName.addEventListener('input', function () { if (playerNameError && validName(playerName.value)) playerNameError.hidden = true; });
    }
    if (bundleName) lettersOnly(bundleName);
    var playerNumber = form.querySelector('[data-player-number]');
    var playerNumberError = form.querySelector('[data-player-number-error]');
    function validNumber(v) { return /^[0-9]{1,2}$/.test(String(v || '').trim()); }
    function digitsOnly(input) {
      input.addEventListener('input', function () {
        var clean = input.value.replace(/[^0-9]/g, '').slice(0, 2);
        if (clean !== input.value) input.value = clean;
        if (validNumber(input.value)) input.classList.remove('is-missing');
      });
    }

    var extrasBox = form.querySelector('[data-extras]');
    var extraChecks = extrasBox ? Array.prototype.slice.call(extrasBox.querySelectorAll('[data-extra]')) : [];
    var extraNumber = extrasBox ? extrasBox.querySelector('[data-extra-number]') : null;
    var extraNumberBox = extrasBox ? extrasBox.querySelector('[data-extra-number-box]') : null;
    var extraNumberError = extrasBox ? extrasBox.querySelector('[data-extra-number-error]') : null;
    var extraAddonId = extrasBox ? parseInt(extrasBox.dataset.addonId, 10) || 0 : 0;
    var extras = [[]];
    var extraNums = [''];
    function extrasNow() { return extraChecks.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); }
    function showExtraNumber() { if (extraNumberBox) extraNumberBox.hidden = !extrasNow().length; }
    extraChecks.forEach(function (c) { c.addEventListener('change', showExtraNumber); });
    if (extraNumber) {
      digitsOnly(extraNumber);
      extraNumber.addEventListener('input', function () { if (extraNumberError && validNumber(extraNumber.value)) extraNumberError.hidden = true; });
    }
    function showExtras(i) {
      var on = extras[i] || [];
      extraChecks.forEach(function (c) { c.checked = on.indexOf(c.value) > -1; });
      if (extraNumber) { extraNumber.value = extraNums[i] || ''; extraNumber.classList.remove('is-missing'); }
      showExtraNumber();
    }
    function extraLines(line, labels, value, addonId, key) {
      if (addonId === undefined) addonId = extraAddonId;
      key = key || 'Number';
      if (!addonId || !labels.length) return [];
      var gid = (line.properties && line.properties._group) || 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      line.properties = Object.assign({}, line.properties || {}, { _group: gid });
      return labels.map(function (label) {
        var props = { _group: gid };
        props[key] = value;
        props['Printed on'] = label;
        return { id: addonId, quantity: line.quantity, properties: props };
      });
    }

    var nameExtrasBox = form.querySelector('[data-extras-name]');
    var nameChecks = nameExtrasBox ? Array.prototype.slice.call(nameExtrasBox.querySelectorAll('[data-extra-name]')) : [];
    var extraName = nameExtrasBox ? nameExtrasBox.querySelector('[data-extra-name-input]') : null;
    var extraNameBox = nameExtrasBox ? nameExtrasBox.querySelector('[data-extra-name-box]') : null;
    var nameAddonId = nameExtrasBox ? parseInt(nameExtrasBox.dataset.addonId, 10) || 0 : 0;
    var nameExtras = [[]];
    var extraNames = [''];
    if (extraName) lettersOnly(extraName);
    function nameExtrasNow() { return nameChecks.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); }
    function showExtraName() { if (extraNameBox) extraNameBox.hidden = !nameExtrasNow().length; }
    nameChecks.forEach(function (c) { c.addEventListener('change', function () { showExtraName(); updatePrice(); }); });
    extraChecks.forEach(function (c) { c.addEventListener('change', function () { updatePrice(); }); });
    function showNameExtras(i) {
      var on = nameExtras[i] || [];
      nameChecks.forEach(function (c) { c.checked = on.indexOf(c.value) > -1; });
      if (extraName) { extraName.value = extraNames[i] || ''; extraName.classList.remove('is-missing'); }
      showExtraName();
    }
    if (form.querySelector('[data-pdp-bundle]')) {
      bundleExtraCents = function () {
        var b = form.querySelector('[data-pdp-bundle]');
        var inc = String((b && b.dataset.includedCents) || '0,0').split(',');
        var cents = (parseInt(inc[0], 10) || 0) + (parseInt(inc[1], 10) || 0);
        if (extrasBox) cents += extrasNow().length * (parseInt(extrasBox.dataset.addonCents, 10) || 0);
        if (nameExtrasBox) cents += nameExtrasNow().length * (parseInt(nameExtrasBox.dataset.addonCents, 10) || 0);
        return cents + lsCents(bundleSelects.map(function (s) { return s.value; }));
      };
      // Each package keeps its own extra prints; the one open on screen is not saved yet.
      bundleTotalCents = function (n) {
        var b = form.querySelector('[data-pdp-bundle]');
        var inc = String((b && b.dataset.includedCents) || '0,0').split(',');
        var each = (parseInt(inc[0], 10) || 0) + (parseInt(inc[1], 10) || 0);
        var numberCents = extrasBox ? parseInt(extrasBox.dataset.addonCents, 10) || 0 : 0;
        var nameCents = nameExtrasBox ? parseInt(nameExtrasBox.dataset.addonCents, 10) || 0 : 0;
        var cents = 0;
        for (var i = 0; i < n; i++) {
          var shown = sameAll || i === active;
          cents += each;
          if (extrasBox) cents += (shown ? extrasNow() : extras[i] || []).length * numberCents;
          if (nameExtrasBox) cents += (shown ? nameExtrasNow() : nameExtras[i] || []).length * nameCents;
          cents += lsCents(shown ? bundleSelects.map(function (s) { return s.value; }) : sets[i] || []);
        }
        return cents;
      };
    }

    var orderedCodes = {};
    try {
      (JSON.parse((form.querySelector('[data-players-ordered]') || {}).textContent || '[]') || []).forEach(function (c) { orderedCodes[c] = true; });
    } catch (e) { orderedCodes = {}; }
    var numbersBox = form.querySelector('[data-numbers-ordered]');
    var orderedNumbers = {};
    try { orderedNumbers = JSON.parse((numbersBox || {}).textContent || '{}') || {}; } catch (e) { orderedNumbers = {}; }
    function numKey(n) { return String(n || '').trim().replace(/^0+(?=\d)/, ''); }
    function takenText(number, team) { return ((numbersBox && numbersBox.dataset.taken) || '').replace('[number]', number).replace('[team]', team); }

    var roster = (function () {
      var box = form.querySelector('[data-roster]');
      if (!box) return { sync: function () {}, check: function () {}, teamOf: function () { return ''; }, numberTaken: function () { return false; }, hasNumber: function () { return false; } };
      var teams = [];
      try { teams = JSON.parse(box.querySelector('[data-roster-json]').textContent) || []; } catch (e) { teams = []; }
      // Teams and the players in each are listed A to Z; numbers count by value, so U9 comes before U10.
      var alpha = function (x, y) { return String(x.name || '').localeCompare(String(y.name || ''), undefined, { numeric: true, sensitivity: 'base' }); };
      teams.forEach(function (t) { if (t.players) t.players.sort(alpha); });
      teams.sort(alpha);
      var teamSel = box.querySelector('[data-roster-team]');
      var playerSel = box.querySelector('[data-roster-player]');
      var gkNote = box.querySelector('[data-roster-gk]');
      var nameIn = form.querySelector('[data-bundle-name]') || form.querySelector('[data-player-name]');
      var numberIn = form.querySelector('[data-bundle-number]') || form.querySelector('[data-player-number]');
      var OTHER = 'other';
      // One order per player: players who already have a kit can't be picked, and none can be typed in.
      var force = box.hasAttribute('data-force');
      function ordered(p) { return !!(p && orderedCodes[playerCode(p.name)]); }
      function option(value, text) {
        var o = document.createElement('option');
        o.value = value;
        o.textContent = text;
        playerSel.appendChild(o);
      }
      function fillPlayers() {
        var team = teams[teamSel.value];
        playerSel.innerHTML = '';
        option('', box.dataset.choosePlayer || '');
        if (team) {
          (team.players || []).forEach(function (p, i) {
            option(String(i), (p.number ? p.number + ' · ' : '') + p.name + (ordered(p) ? ' · ' + (box.dataset.ordered || '') : ''));
            if (ordered(p)) playerSel.lastChild.disabled = true;
          });
          if (!force) option(OTHER, box.dataset.notListed || '');
        }
        playerSel.disabled = !team;
      }
      // Name and number stay closed until a player is picked. A listed player without a number gets to type one in,
      // and "My player isn't listed" opens both.
      var current = null;
      function lock(on, p, typed) {
        current = on ? p || null : null;
        [nameIn, numberIn].forEach(function (el) {
          if (!el) return;
          var shut = !(typed && !force) && !(el === numberIn && current && !current.number);
          el.readOnly = shut;
          el.classList.toggle('is-locked', shut);
        });
        checkTyped();
      }
      function teamNamed(name) { return teams.filter(function (t) { return t.name === name; })[0]; }
      // Taken when another player of the team has it on the list or on an earlier order.
      function numberTaken(teamName, number, name) {
        var code = playerCode(name);
        var n = numKey(number);
        var t = teamNamed(teamName);
        var listed = t && (t.players || []).some(function (p) { return numKey(p.number) === n && playerCode(p.name) !== code; });
        var was = (orderedNumbers[teamName] || {})[n];
        return !!(n && (listed || (was && was !== code)));
      }
      function hasNumber(teamName, name) {
        var code = playerCode(name);
        var t = teamNamed(teamName);
        return !!(t && (t.players || []).some(function (p) { return p.number && playerCode(p.name) === code; }));
      }
      function checkTyped() {
        var err = numberIn && numberIn.parentNode.querySelector('[data-number-taken-error]');
        if (!err) return;
        var team = teams[teamSel.value];
        var n = numberIn.value.trim();
        var bad = !!(current && !current.number && team && numberTaken(team.name, n, current.name));
        err.textContent = bad ? takenText(n, team.name) : '';
        err.hidden = !bad;
        numberIn.classList.toggle('is-missing', bad);
      }
      function put(el, v) {
        if (!el) return;
        el.value = v;
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }
      function goalie(p) { if (gkNote) gkNote.hidden = !(p && p.goalie); }

      // Search ignores capitals, accents and punctuation, so "oconnell" finds O'Connell.
      function fold(s) {
        return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/['’.-]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
      }
      function code(name) { var m = /^(boys|girls)\s+u(\d+)\s*(.*)$/i.exec(name || ''); return m ? (m[1][0] + 'u' + m[2] + ' ' + m[3]) : ''; }
      function matches(hay, q) {
        var words = fold(q).split(/\s+/).filter(Boolean);
        var h = fold(hay);
        return words.every(function (w) { return h.indexOf(w) > -1; });
      }
      var comboCount = 0;
      function combo(sel, cfg) {
        var n = ++comboCount;
        var wrap = document.createElement('div');
        wrap.className = 'sannico-pdp__combo';
        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'sannico-pdp__roster-select sannico-pdp__combo-input';
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('spellcheck', 'false');
        if (sel.id) { input.id = sel.id; sel.removeAttribute('id'); }
        var list = document.createElement('ul');
        list.className = 'sannico-pdp__combo-list';
        list.setAttribute('role', 'listbox');
        list.id = 'sannico-combo-' + n + '-' + (input.id || 'list');
        list.hidden = true;
        input.setAttribute('aria-controls', list.id);
        sel.hidden = true;
        sel.setAttribute('aria-hidden', 'true');
        sel.tabIndex = -1;
        sel.parentNode.insertBefore(wrap, sel);
        wrap.appendChild(input);
        wrap.appendChild(list);
        var shown = [];
        var at = -1;
        function show() {
          input.value = cfg.label();
          input.placeholder = cfg.placeholder();
          input.disabled = !!(cfg.disabled && cfg.disabled());
        }
        function mark(i) {
          at = i;
          var items = list.children;
          for (var k = 0; k < items.length; k++) items[k].setAttribute('aria-selected', k === at ? 'true' : 'false');
          if (at > -1 && items[at]) {
            input.setAttribute('aria-activedescendant', items[at].id);
            items[at].scrollIntoView({ block: 'nearest' });
          } else input.removeAttribute('aria-activedescendant');
        }
        function render() {
          shown = cfg.items(input.value);
          list.innerHTML = '';
          shown.forEach(function (it, k) {
            var li = document.createElement('li');
            li.id = list.id + '-' + k;
            li.className = 'sannico-pdp__combo-option' + (it.other ? ' is-other' : '') + (it.disabled ? ' is-disabled' : '');
            li.setAttribute('role', 'option');
            if (it.disabled) li.setAttribute('aria-disabled', 'true');
            var main = document.createElement('span');
            main.textContent = it.label;
            li.appendChild(main);
            if (it.sub) {
              var sub = document.createElement('span');
              sub.className = 'sannico-pdp__combo-sub';
              sub.textContent = it.sub;
              li.appendChild(sub);
            }
            // mousedown, not click: the pick happens before the input loses focus.
            li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(k); });
            list.appendChild(li);
          });
          if (!shown.length) {
            var none = document.createElement('li');
            none.className = 'sannico-pdp__combo-empty';
            none.textContent = cfg.empty(input.value);
            list.appendChild(none);
          }
          // Never highlight "My player isn't listed": Enter would clear the name.
          var first = -1;
          for (var f = 0; f < shown.length; f++) if (!shown[f].other && !shown[f].disabled) { first = f; break; }
          mark(input.value.trim() ? first : -1);
        }
        function openList() {
          if (input.disabled) return;
          render();
          list.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
        function closeList() {
          list.hidden = true;
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
          show();
        }
        function pick(k) {
          var it = shown[k];
          if (!it || it.disabled) return;
          cfg.pick(it);
          closeList();
          if (window.innerWidth < 750 && document.activeElement === input) input.blur();
        }
        input.addEventListener('focus', function () {
          input.value = '';
          openList();
          // On a phone the keyboard takes half the screen: bring the box up so the list shows.
          var r = input.getBoundingClientRect();
          if (window.innerWidth < 750 && r.top > 120) window.scrollBy({ top: r.top - 90, behavior: 'smooth' });
        });
        input.addEventListener('click', function () { if (list.hidden) { input.value = ''; openList(); } });
        input.addEventListener('input', openList);
        input.addEventListener('blur', closeList);
        input.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (list.hidden) openList();
            if (!shown.length) return;
            var next = at + (e.key === 'ArrowDown' ? 1 : -1);
            mark(next < 0 ? shown.length - 1 : next >= shown.length ? 0 : next);
          } else if (e.key === 'Enter') {
            if (list.hidden) return;
            e.preventDefault();
            pick(at);
          } else if (e.key === 'Escape') {
            if (!list.hidden) { e.preventDefault(); closeList(); }
          }
        });
        show();
        return { show: show };
      }

      var teamBox = combo(teamSel, {
        label: function () { var t = teams[teamSel.value]; return t ? t.name : ''; },
        placeholder: function () { return box.dataset.chooseTeam || ''; },
        items: function (q) {
          var out = [];
          teams.forEach(function (t, i) { if (!q.trim() || matches(t.name + ' ' + code(t.name), q)) out.push({ value: String(i), label: t.name }); });
          return out;
        },
        empty: function () { return box.dataset.noMatch || ''; },
        pick: function (it) {
          if (teamSel.value === it.value) return;
          teamSel.value = it.value;
          teamSel.dispatchEvent(new Event('change', { bubbles: true }));
        },
      });
      var playerBox = combo(playerSel, {
        label: function () {
          var team = teams[teamSel.value];
          if (playerSel.value === OTHER) return box.dataset.notListed || '';
          var p = team && team.players ? team.players[playerSel.value] : null;
          return p ? (p.number ? p.number + ' · ' : '') + p.name : '';
        },
        placeholder: function () { return teams[teamSel.value] ? (box.dataset.choosePlayer || '') : (box.dataset.searchPlayer || ''); },
        items: function (q) {
          var team = teams[teamSel.value];
          var out = [];
          if (team) {
            (team.players || []).forEach(function (p, i) {
              if (!q.trim() || matches(p.name + ' ' + (p.number || ''), q)) out.push({ team: teamSel.value, value: String(i), label: (p.number ? p.number + ' · ' : '') + p.name, sub: ordered(p) ? box.dataset.ordered : '', disabled: ordered(p) });
            });
            if (!force) out.push({ team: teamSel.value, value: OTHER, label: box.dataset.notListed || '', other: true });
            return out;
          }
          if (fold(q).replace(/\s+/g, '').length < 2) return [];
          teams.forEach(function (t, ti) {
            (t.players || []).forEach(function (p, i) {
              if (out.length < 50 && matches(p.name + ' ' + (p.number || ''), q)) out.push({ team: String(ti), value: String(i), label: (p.number ? p.number + ' · ' : '') + p.name, sub: t.name + (ordered(p) ? ' · ' + (box.dataset.ordered || '') : ''), disabled: ordered(p) });
            });
          });
          return out;
        },
        empty: function (q) { return !teams[teamSel.value] && fold(q).replace(/\s+/g, '').length < 2 ? (box.dataset.typeName || '') : (box.dataset.noMatch || ''); },
        pick: function (it) {
          if (teamSel.value !== it.team) {
            teamSel.value = it.team;
            teamSel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          playerSel.value = it.value;
          playerSel.dispatchEvent(new Event('change', { bubbles: true }));
        },
      });
      function showBoxes() { teamBox.show(); playerBox.show(); }
      playerSel.addEventListener('change', showBoxes);

      teamSel.addEventListener('change', function () {
        fillPlayers();
        lock(false);
        put(nameIn, '');
        put(numberIn, '');
        goalie(null);
        showBoxes();
      });
      playerSel.addEventListener('change', function () {
        var team = teams[teamSel.value];
        var p = team && team.players ? team.players[playerSel.value] : null;
        if (!p) {
          lock(false, null, playerSel.value === OTHER);
          put(nameIn, '');
          put(numberIn, '');
          goalie(null);
          if (playerSel.value === OTHER && (nameIn || numberIn)) (nameIn || numberIn).focus();
          return;
        }
        put(nameIn, p.name);
        put(numberIn, p.number || '');
        lock(true, p);
        goalie(p);
      });
      function sync() {
        match();
        showBoxes();
      }
      function match() {
        var name = nameIn ? nameIn.value.trim().toLowerCase() : '';
        var number = numberIn ? numberIn.value.trim() : '';
        if (!name && !number) {
          if (teamSel.value !== '') { fillPlayers(); playerSel.value = ''; }
          lock(false);
          goalie(null);
          return;
        }
        for (var t = 0; t < teams.length; t++) {
          var players = teams[t].players || [];
          for (var i = 0; i < players.length; i++) {
            var p = players[i];
            if ((!nameIn || p.name.toLowerCase() === name) && (!numberIn || String(p.number || '') === number || (nameIn && !p.number))) {
              teamSel.value = String(t);
              fillPlayers();
              playerSel.value = String(i);
              lock(true, p);
              goalie(p);
              return;
            }
          }
        }
        if (teamSel.value !== '') { fillPlayers(); playerSel.value = OTHER; }
        lock(false, null, true);
        goalie(null);
      }
      // The team is looked up from the club list, so only listed players get one.
      function teamOf(name, number) {
        var n = String(name || '').trim().toLowerCase();
        var num = String(number || '').trim();
        if (!n && !num) return '';
        for (var t = 0; t < teams.length; t++) {
          var players = teams[t].players || [];
          for (var i = 0; i < players.length; i++) {
            var p = players[i];
            if ((!nameIn || p.name.toLowerCase() === n) && (!numberIn || String(p.number || '') === num || (nameIn && !p.number))) return teams[t].name || '';
          }
        }
        return '';
      }
      // The boxes are closed from the start, until a player is picked.
      sync();
      return { sync: sync, check: checkTyped, teamOf: teamOf, numberTaken: numberTaken, hasNumber: hasNumber };
    })();
    if (playerNumber) {
      digitsOnly(playerNumber);
      playerNumber.addEventListener('input', function () { if (playerNumberError && validNumber(playerNumber.value)) playerNumberError.hidden = true; });
    }
    if (bundleNumber) digitsOnly(bundleNumber);
    if (bundleNumber || playerNumber) (bundleNumber || playerNumber).addEventListener('input', roster.check);
    var tickSvg = '<svg class="sannico-pdp__bundle-tab-tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

    function packages() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    // A long sleeve size costs a little more; each item that offers it says how much (data-ls-cents on its size box).
    function lsOn(select, value) {
      if (!select || !value || !select.dataset.lsCents) return false;
      var o = select.querySelector('option[value="' + CSS.escape(value) + '"]');
      return !!(o && o.hasAttribute('data-ls'));
    }
    function lsCents(values) {
      var cents = 0;
      bundleSelects.forEach(function (s, k) { if (lsOn(s, (values || [])[k])) cents += parseInt(s.dataset.lsCents, 10) || 0; });
      return cents;
    }
    function save() {
      sets[active] = bundleSelects.map(function (s) { return s.value; });
      if (bundleNumber) numbers[active] = bundleNumber.value.trim();
      if (bundleName) names[active] = cleanName(bundleName.value);
      if (extrasBox) {
        extras[active] = extrasNow();
        extraNums[active] = extraNumber ? extraNumber.value.trim() : '';
      }
      if (nameExtrasBox) {
        nameExtras[active] = nameExtrasNow();
        extraNames[active] = extraName ? cleanName(extraName.value) : '';
      }
    }
    function complete(i) {
      var v = sets[i] || [];
      if (bundleNumber && !validNumber(numbers[i])) return false;
      if (bundleName && !validName(names[i])) return false;
      if (extraNumber && (extras[i] || []).length && !validNumber(extraNums[i])) return false;
      if (extraName && (nameExtras[i] || []).length && !validName(extraNames[i])) return false;
      return bundleSelects.every(function (s, k) { return !!v[k]; });
    }
    function say(key, map) {
      var t = (bundle && bundle.dataset[key]) || '';
      Object.keys(map).forEach(function (k) { t = t.split('[' + k + ']').join(map[k]); });
      return t;
    }

    function markRows() {
      bundleSelects.forEach(function (s) {
        var row = s.closest('.sannico-pdp__bundle-item');
        if (row) row.toggleAttribute('data-done', !!s.value);
        if (s.value) s.classList.remove('is-missing');
      });
    }

    function renderTabs() {
      if (!bundleTabs) return;
      var n = sets.length;
      if (bundleRemove) {
        var min = (qtyInput && parseInt(qtyInput.min, 10)) || 1;
        bundleRemove.hidden = n < 2 || n - 1 < min;
        bundleRemove.textContent = say('remove', { n: active + 1 });
      }
      bundleTabs.hidden = n < 2;
      if (n < 2) { bundleTabs.innerHTML = ''; return; }
      var html = '<span class="sannico-pdp__bundle-tabs-label" aria-hidden="true">' + say('tabsLabel', {}) + '</span>';
      for (var i = 0; i < n; i++) {
        html += '<button type="button" role="tab" class="sannico-pdp__bundle-tab' + (complete(i) ? ' is-done' : '') + '" data-bundle-tab="' + i + '" aria-selected="' + (i === active) + '" aria-label="' + say('tab', { n: i + 1 }) + '">' +
          (i + 1) + tickSvg + '</button>';
      }
      bundleTabs.innerHTML = html;
    }

    function refresh() {
      if (!bundle) return;
      save();
      var n = sets.length;
      var ready = 0;
      for (var i = 0; i < n; i++) if (complete(i)) ready++;
      var all = ready === n;
      bundle.classList.toggle('is-ready', all);
      if (bundleProgress) {
        if (all) bundleProgress.textContent = bundle.dataset.ready;
        else if (n > 1) bundleProgress.textContent = say('progressMany', { ready: ready, count: n });
        else {
          var done = bundleSelects.filter(function (s) { return s.value; }).length;
          bundleProgress.textContent = say('progress', { done: done, total: bundleSelects.length });
        }
      }
      if (all && bundleError) bundleError.hidden = true;
      if (bundleTabs) {
        bundleTabs.querySelectorAll('[data-bundle-tab]').forEach(function (t) {
          var i = parseInt(t.dataset.bundleTab, 10);
          t.classList.toggle('is-done', complete(i));
          if (complete(i)) t.classList.remove('is-missing');
        });
      }
      markRows();
    }

    function open(i) {
      save();
      active = i;
      var v = sets[i] || [];
      bundleSelects.forEach(function (s, k) { s.value = v[k] || ''; s.classList.remove('is-missing'); });
      if (bundleNumber) { bundleNumber.value = numbers[i] || ''; bundleNumber.classList.remove('is-missing'); }
      if (bundleName) { bundleName.value = names[i] || ''; bundleName.classList.remove('is-missing'); }
      roster.sync();
      if (extrasBox) showExtras(i);
      if (nameExtrasBox) showNameExtras(i);
      if (bundleExtraCents) updatePrice();
      if (bundleList) {
        bundleList.classList.remove('is-swap');
        void bundleList.offsetWidth;
        bundleList.classList.add('is-swap');
      }
      renderTabs();
      refresh();
    }

    var teamHint = form.querySelector('[data-team-hint]');
    var teamLink = form.querySelector('[data-team-link]');
    function showTeamHint(n) {
      if (!teamHint) return;
      teamHint.hidden = n < 2;
      if (teamLink) teamLink.href = teamHint.dataset.teamUrl + '&players=' + n;
    }

    function resize() {
      if (!bundle) return;
      save();
      var n = packages();
      showTeamHint(n);
      if (sameRow) sameRow.hidden = n < 2 || !!bundleNumber || !!bundleName;
      while (numbers.length < n) numbers.push('');
      numbers.length = Math.max(1, n);
      while (names.length < n) names.push('');
      names.length = Math.max(1, n);
      while (extras.length < n) extras.push([]);
      extras.length = Math.max(1, n);
      while (extraNums.length < n) extraNums.push('');
      extraNums.length = Math.max(1, n);
      while (nameExtras.length < n) nameExtras.push([]);
      nameExtras.length = Math.max(1, n);
      while (extraNames.length < n) extraNames.push('');
      extraNames.length = Math.max(1, n);
      if (sameText) sameText.textContent = say('same', { count: n });
      if (sameAll || n < 2) {
        sets = [sets[active] || []];
        active = 0;
      } else {
        // New packages start blank so every player's sizes are picked on purpose.
        while (sets.length < n) sets.push([]);
        sets.length = n;
        if (active > n - 1) active = n - 1;
      }
      open(active);
    }
    if (sameBox) {
      sameBox.addEventListener('change', function () {
        save();
        sameAll = sameBox.checked;
        if (!sameAll) {
          var base = sets[active] || [];
          sets = [base];
          active = 0;
        }
        resize();
      });
    }
    if (bundle && qtyInput) qtyInput.addEventListener('pdp:qty', resize);
    if (bundle && qtyInput) {
      qtyInput.addEventListener('pdp:qty', updateTotal);
      qtyInput.addEventListener('input', updateTotal);
    }

    if (bundleRemove && qtyInput) {
      bundleRemove.addEventListener('click', function () {
        save();
        var n = sets.length;
        if (n < 2) return;
        sets.splice(active, 1);
        numbers.splice(active, 1);
        names.splice(active, 1);
        extras.splice(active, 1);
        extraNums.splice(active, 1);
        nameExtras.splice(active, 1);
        extraNames.splice(active, 1);
        if (active > n - 2) active = n - 2;
        // Show the package now open, so resize() saves its sizes, not the removed one's.
        var v = sets[active] || [];
        bundleSelects.forEach(function (s, k) { s.value = v[k] || ''; });
        if (bundleNumber) bundleNumber.value = numbers[active] || '';
        if (bundleName) bundleName.value = names[active] || '';
        roster.sync();
        if (extrasBox) showExtras(active);
        if (nameExtrasBox) showNameExtras(active);
        qtyInput.value = n - 1;
        markActiveTier(clampQty(true));
        qtyInput.dispatchEvent(new CustomEvent('pdp:qty'));
      });
    }

    bundleSelects.forEach(function (s) {
      s.addEventListener('change', refresh);
      if (s.dataset.lsCents) s.addEventListener('change', function () { updatePrice(); });
    });
    if (bundleNumber) bundleNumber.addEventListener('input', refresh);
    if (bundleName) bundleName.addEventListener('input', refresh);
    if (bundleTabs) {
      bundleTabs.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bundle-tab]');
        if (t) open(parseInt(t.dataset.bundleTab, 10));
      });
    }

    function bundleCheck() {
      save();
      var first = -1;
      for (var i = 0; i < sets.length; i++) if (!complete(i)) { first = i; break; }
      if (first < 0) return true;
      if (first !== active) open(first);
      if (bundleTabs) {
        bundleTabs.querySelectorAll('[data-bundle-tab]').forEach(function (t) {
          t.classList.toggle('is-missing', !complete(parseInt(t.dataset.bundleTab, 10)));
        });
      }
      var missing = bundleSelects.filter(function (s) { return !s.value; });
      missing.forEach(function (s) { s.classList.add('is-missing'); });
      var sizesDone = !missing.length;
      var nameMissing = bundleName && !validName(bundleName.value);
      if (nameMissing) { bundleName.classList.add('is-missing'); missing.unshift(bundleName); }
      var numberMissing = bundleNumber && !validNumber(bundleNumber.value);
      if (numberMissing) { bundleNumber.classList.add('is-missing'); missing.push(bundleNumber); }
      var extraMissing = extraNumber && extrasNow().length && !validNumber(extraNumber.value);
      if (extraMissing) { extraNumber.classList.add('is-missing'); missing.push(extraNumber); }
      var extraNameMissing = extraName && nameExtrasNow().length && !validName(extraName.value);
      if (extraNameMissing) { extraName.classList.add('is-missing'); missing.push(extraName); }
      if (bundleError) {
        if (nameMissing && sizesDone) bundleError.textContent = bundleError.dataset.nameMissing;
        else if (numberMissing && sizesDone) bundleError.textContent = bundleError.dataset.numberMissing;
        else if (extraMissing && sizesDone) bundleError.textContent = bundleError.dataset.extraMissing;
        else if (extraNameMissing && sizesDone) bundleError.textContent = bundleError.dataset.extraNameMissing;
        else bundleError.textContent = sets.length > 1 ? say('missingIn', { n: first + 1 }) : bundleError.dataset.one || bundleError.textContent;
        bundleError.hidden = false;
      }
      if (missing[0]) missing[0].focus();
      return false;
    }
    if (bundleError) bundleError.dataset.one = bundleError.textContent;

    // The package's real items ride on a hidden property, so checkout can split it and tax kids'
    // sizes at the lower rate. Left off when a size cannot be matched.
    var bundleItems = Array.prototype.slice.call(form.querySelectorAll('[data-bundle-item]'));
    var packageHandle = (bundle && bundle.dataset.packageHandle) || '';
    function packageItems(v) {
      var items = [];
      for (var i = 0; i < bundleItems.length; i++) {
        var li = bundleItems[i];
        var map;
        try { map = JSON.parse(li.dataset.bundleVariants || '{}'); } catch (e) { return null; }
        var select = li.querySelector('[data-bundle-size]');
        var size = select ? v[bundleSelects.indexOf(select)] : Object.keys(map)[0];
        var id = map[size];
        var qty = parseInt(li.dataset.bundleQty, 10);
        if (!id || !(qty > 0)) return null;
        items.push({ v: id, q: qty });
      }
      return items.length ? JSON.stringify({ items: items }) : null;
    }
    function withItems(props, v) {
      var items = packageHandle && packageItems(v || []);
      if (items) {
        props._package = packageHandle;
        props._package_items = items;
        // Checkout charges the long sleeve extra from this field, and refuses a long sleeve size without it.
        var fields = {};
        bundleSelects.forEach(function (s, k) { if (lsOn(s, (v || [])[k])) fields[s.dataset.lsKey] = '1'; });
        if (Object.keys(fields).length) props._package_fields = JSON.stringify(fields);
      }
      return props;
    }
    function bundleLines(baseId) {
      save();
      var lines = [];
      var byKey = {};
      var extraFor = function (i) { return extrasBox ? extras[i] || [] : []; };
      var extraNumberFor = function (i) { return bundleNumber ? numbers[i] : extraNums[i] || ''; };
      var nameExtraFor = function (i) { return nameExtrasBox ? nameExtras[i] || [] : []; };
      var extraNameFor = function (i) { return bundleName ? names[i] : extraNames[i] || ''; };
      var printsFor = function (line, i) {
        return extraLines(line, extraFor(i), extraNumberFor(i))
          .concat(extraLines(line, nameExtraFor(i), extraNameFor(i), nameAddonId, 'Name'));
      };
      if (sameAll) {
        var one = {};
        bundleSelects.forEach(function (s, k) { one[s.dataset.bundleLabel] = (sets[0] || [])[k]; });
        var all = { id: baseId, quantity: packages(), properties: withItems(one, sets[0]) };
        return [all].concat(printsFor(all, 0));
      }
      var extraOf = [];
      sets.forEach(function (v, i) {
        var props = {};
        if (bundleName) props.Name = names[i];
        if (bundleNumber) props.Number = numbers[i];
        var team = (bundleName || bundleNumber) ? roster.teamOf(names[i], numbers[i]) : '';
        if (team) props.Team = team;
        bundleSelects.forEach(function (s, k) { props[s.dataset.bundleLabel] = v[k]; });
        withItems(props, v);
        var key = JSON.stringify(props) + '|' + extraFor(i).join(',') + '|' + extraNumberFor(i) + '|' + nameExtraFor(i).join(',') + '|' + extraNameFor(i);
        if (byKey[key]) { byKey[key].quantity++; return; }
        byKey[key] = { id: baseId, quantity: 1, properties: props };
        lines.push(byKey[key]);
        extraOf.push(i);
      });
      var withExtras = [];
      lines.forEach(function (line, n) {
        withExtras.push(line);
        withExtras = withExtras.concat(printsFor(line, extraOf[n]));
      });
      return withExtras;
    }
    if (bundle) resize();

    // Optional extras: ordinary items at their own price, added to the cart beside the package.
    var optionalBox = form.querySelector('[data-optional]');
    var optionalRows = optionalBox ? Array.prototype.slice.call(optionalBox.querySelectorAll('[data-optional-item]')).map(function (row) {
      var variants = [];
      try { variants = JSON.parse(row.dataset.variants || '[]'); } catch (e) { variants = []; }
      var size = row.querySelector('[data-optional-size]');
      variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = String(v.id);
        o.textContent = v.s;
        size.appendChild(o);
      });
      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = optionalBox.dataset.choose || '';
      size.insertBefore(blank, size.firstChild);
      size.value = variants.length === 1 ? String(variants[0].id) : '';
      return {
        el: row,
        label: row.dataset.label || '',
        variants: variants,
        check: row.querySelector('[data-optional-check]'),
        pick: row.querySelector('[data-optional-pick]'),
        size: size,
        qty: row.querySelector('[data-optional-qty]'),
        one: variants.length === 1,
        oneText: row.querySelector('[data-optional-one]'),
        chips: row.querySelector('[data-optional-chips]'),
        sizeLabel: row.querySelector('[data-optional-sizelabel]'),
        sub: row.querySelector('[data-optional-sub]'),
        price: row.querySelector('[data-optional-price]'),
      };
    }) : [];
    var optionalError = optionalBox ? optionalBox.querySelector('[data-optional-error]') : null;
    function optionalQty(r) { return Math.min(20, Math.max(0, parseInt(r.qty.value, 10) || 0)); }
    function optionalVariant(r) {
      for (var i = 0; i < r.variants.length; i++) if (String(r.variants[i].id) === r.size.value) return r.variants[i];
      return null;
    }
    function showOptionalPrice(r) {
      var v = optionalVariant(r);
      var cents = v ? v.p : Math.min.apply(null, r.variants.map(function (x) { return x.p; }));
      r.price.textContent = r.variants.length ? money(cents) : '';
    }
    optionalCents = function () {
      var cents = 0;
      optionalRows.forEach(function (r) {
        var v = optionalQty(r) > 0 && optionalVariant(r);
        if (v) cents += v.p * optionalQty(r);
      });
      return cents;
    };
    optionalRows.forEach(function (r) {
      showOptionalPrice(r);
      function changed() {
        r.pick.hidden = !r.check.checked;
        if (optionalQty(r) > 0 && r.size.value) r.chips.classList.remove('is-missing');
        Array.prototype.forEach.call(r.chips.children, function (chip, i) {
          var on = String(r.variants[i].id) === r.size.value;
          chip.classList.toggle('is-on', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (optionalError) optionalError.hidden = true;
        showOptionalPrice(r);
        var picked = optionalVariant(r);
        r.sub.textContent = picked && optionalQty(r) ? money(picked.p * optionalQty(r)) : '';
        r.el.classList.toggle('is-in', optionalQty(r) > 0);
        updateTotal();
      }
      if (r.one) { r.oneText.hidden = false; r.chips.hidden = true; r.sizeLabel.hidden = true; }
      else {
        r.variants.forEach(function (v) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'sannico-pdp__optional-chip';
          chip.textContent = v.s;
          chip.setAttribute('aria-pressed', 'false');
          chip.addEventListener('click', function () {
            r.size.value = r.size.value === String(v.id) ? '' : String(v.id);
            if (r.size.value && !optionalQty(r)) r.qty.value = 1;
            r.size.dispatchEvent(new Event('change'));
          });
          r.chips.appendChild(chip);
        });
      }
      r.el.querySelectorAll('[data-optional-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          r.qty.value = Math.min(20, Math.max(0, optionalQty(r) + parseInt(b.dataset.optionalStep, 10)));
          changed();
        });
      });
      r.check.addEventListener('change', changed);
      r.size.addEventListener('change', changed);
    });
    function optionalCheck() {
      for (var i = 0; i < optionalRows.length; i++) {
        var r = optionalRows[i];
        if (optionalQty(r) > 0 && !optionalVariant(r)) {
          r.chips.classList.add('is-missing');
          if (optionalError) {
            optionalError.textContent = (optionalBox.dataset.missing || '').replace('[name]', r.label);
            optionalError.hidden = false;
          }
          if (r.chips.firstChild) r.chips.firstChild.focus();
          return false;
        }
      }
      return true;
    }
    function optionalLines() {
      var out = [];
      optionalRows.forEach(function (r) {
        var v = optionalQty(r) > 0 && optionalVariant(r);
        if (v) out.push({ id: v.id, quantity: optionalQty(r), properties: { '_optional_for': r.el.dataset.package || '' } });
      });
      return out;
    }

    var limitError = form.querySelector('[data-limit-error]');
    function showLimit(text) {
      if (!limitError) return;
      limitError.textContent = text;
      limitError.hidden = false;
    }

    // One kit per player: a name can be on one Player or Goalkeeper package only, matched by letters and digits.
    var KIT = /-(player|goalkeeper)-package$/;
    function nameKey(name) {
      var s = String(name || '').toLowerCase();
      if (/[^\x00-\x7f]/.test(s) && s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return s.replace(/[\s!-/:-@[-`{-~‘’“”´]/g, '');
    }
    function kitName(props) {
      return (props && (props.Name || String(props.Player || '').replace(/\s*#\s*\d+\s*$/, ''))) || '';
    }
    // Same code as shared/player-keys.js, so the page, the Supply Bridge and checkout agree on who a player is.
    function playerCode(name) {
      var key = nameKey(name);
      if (!key) return '';
      var h = 0x811c9dc5;
      for (var i = 0; i < key.length; i++) {
        h ^= key.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
      }
      return h.toString(36);
    }
    function onePerPlayer(adding) {
      if (!form.hasAttribute('data-one-per-player') && !form.querySelector('[data-players-ordered]')) return '';
      var forced = !!form.querySelector('[data-roster][data-force]');
      for (var i = 0; i < adding.length; i++) {
        var p = adding[i].properties || {};
        var name = kitName(p);
        if (!name) continue;
        if (orderedCodes[playerCode(name)]) return (form.dataset.kitOrdered || '').replace('[name]', name);
        if (forced && !roster.teamOf(name, p.Number || '')) return (form.dataset.kitPick || '').replace('[name]', name);
      }
      return '';
    }
    function nameClash(adding, cartItems) {
      var taken = {};
      cartItems.forEach(function (it) {
        if ((editing && it.key === editing.key) || !(KIT.test(it.handle || '') || String(it.product_id) === form.dataset.productId)) return;
        var k = nameKey(kitName(it.properties));
        if (k) taken[k] = true;
      });
      var seen = {};
      for (var i = 0; i < adding.length; i++) {
        var name = kitName(adding[i].properties);
        var k = nameKey(name);
        if (!k) continue;
        if (taken[k]) return (form.dataset.kitInCart || '').replace('[name]', name);
        if (seen[k] || adding[i].quantity > 1) return (form.dataset.kitTwice || '').replace('[name]', name);
        seen[k] = true;
      }
      return '';
    }

    // A number typed for a listed player can't be one another player of the team already has, in the cart too.
    function numberClash(adding, cartItems) {
      var used = {};
      cartItems.forEach(function (it) {
        var p = it.properties || {};
        if ((editing && it.key === editing.key) || !p.Team || !p.Number) return;
        used[p.Team + '|' + numKey(p.Number)] = playerCode(kitName(p));
      });
      for (var i = 0; i < adding.length; i++) {
        var p = adding[i].properties || {};
        var name = kitName(p);
        var n = numKey(p.Number);
        if (!p.Team || !n || !name || roster.hasNumber(p.Team, name)) continue;
        var code = playerCode(name);
        var k = p.Team + '|' + n;
        if ((used[k] && used[k] !== code) || roster.numberTaken(p.Team, n, name)) return takenText(String(p.Number).trim(), p.Team);
        used[k] = code;
      }
      return '';
    }

    function withinLimit(items) {
      var max = parseInt(form.dataset.orderLimit, 10);
      var kit = form.hasAttribute('data-kit');
      if (limitError) limitError.hidden = true;
      if (!max && !kit && !numbersBox) return Promise.resolve(true);
      var mine = items.filter(function (it) { return it.id === parseInt(idInput.value, 10); });
      if (kit) {
        var twice = nameClash(mine, []);
        if (twice) { showLimit(twice); return Promise.resolve(false); }
      }
      var notAgain = onePerPlayer(mine);
      if (notAgain) { showLimit(notAgain); return Promise.resolve(false); }
      var taken = numbersBox ? numberClash(mine, []) : '';
      if (taken) { showLimit(taken); return Promise.resolve(false); }
      var adding = mine.reduce(function (n, it) { return n + it.quantity; }, 0) - (editing ? 1 : 0);
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var inCart = cart.items.filter(function (it) { return String(it.product_id) === form.dataset.productId; })
          .reduce(function (n, it) { return n + it.quantity; }, 0);
        if (max && inCart + adding > max) {
          showLimit((form.dataset.limitMsg || '').replace('[max]', max).replace('[in_cart]', inCart));
          return false;
        }
        var clash = (kit ? nameClash(mine, cart.items) : '') || (numbersBox ? numberClash(mine, cart.items) : '');
        if (clash) { showLimit(clash); return false; }
        return true;
      }).catch(function () { return true; });
    }

    // ?edit=<cart line key> opens a package from the cart with its choices filled in.
    var editing = null;
    var editNote = form.querySelector('[data-editing]');
    var editKey = bundle ? new URLSearchParams(window.location.search).get('edit') : null;
    if (editKey) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = cart.items.filter(function (it) { return it.key === editKey; })[0];
          if (line && String(line.product_id) === form.dataset.productId) startEdit(line, cart.items);
          else if (editNote && editNote.dataset.missing) { editNote.textContent = editNote.dataset.missing; editNote.hidden = false; }
        })
        .catch(function () {});
    }

    function startEdit(line, items) {
      var p = line.properties || {};
      var prints = p._group ? items.filter(function (it) {
        return it.key !== line.key && it.properties && it.properties._group === p._group;
      }) : [];
      editing = {
        key: line.key,
        prints: prints.map(function (it) { return { key: it.key, share: Math.max(1, Math.round(it.quantity / line.quantity)) }; })
      };
      if (qtyInput) qtyInput.value = 1;
      bundleSelects.forEach(function (s) {
        var v = p[s.dataset.bundleLabel];
        if (v != null && s.querySelector('option[value="' + CSS.escape(v) + '"]')) s.value = v;
      });
      if (bundleNumber) bundleNumber.value = p.Number || '';
      if (bundleName) bundleName.value = p.Name || '';
      var onNumber = [];
      var onName = [];
      prints.forEach(function (it) {
        var q = it.properties;
        if (q.Number != null) { onNumber.push(q['Printed on']); if (extraNumber) extraNumber.value = q.Number; }
        else if (q.Name != null) { onName.push(q['Printed on']); if (extraName) extraName.value = q.Name; }
      });
      extraChecks.forEach(function (c) { c.checked = onNumber.indexOf(c.value) > -1; });
      nameChecks.forEach(function (c) { c.checked = onName.indexOf(c.value) > -1; });
      markActiveTier(clampQty(true));
      resize();
      if (cta && cta.dataset.updateLabel) { addLabel = cta.dataset.updateLabel; cta.textContent = addLabel; }
      if (editNote) editNote.hidden = false;
    }

    // Takes the old package (and its prints) out after the new one is in, so nothing is lost if the add fails.
    function finishEdit(added) {
      var was = editing;
      // A package saved unchanged joins its old line, so that line must keep one.
      var fresh = {};
      ((added && added.items) || []).forEach(function (it) { fresh[it.key] = true; });
      var keep = function (key, qty) { return Math.max(fresh[key] ? 1 : 0, qty); };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var qtyOf = {};
          cart.items.forEach(function (it) { qtyOf[it.key] = it.quantity; });
          var updates = {};
          if (qtyOf[was.key]) updates[was.key] = keep(was.key, qtyOf[was.key] - 1);
          was.prints.forEach(function (p) { if (qtyOf[p.key]) updates[p.key] = keep(p.key, qtyOf[p.key] - p.share); });
          Object.keys(updates).forEach(function (k) { if (updates[k] === qtyOf[k]) delete updates[k]; });
          if (!Object.keys(updates).length) return null;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .catch(function () {})
        .then(function () {
          editing = null;
          if (editNote) editNote.hidden = true;
          if (cta) addLabel = cta.dataset.addLabel || addLabel;
          var url = new URL(window.location.href);
          url.searchParams.delete('edit');
          window.history.replaceState(null, '', url.toString());
        });
    }

    form.addEventListener('submit', function (e) {
      var baseId = parseInt(idInput.value, 10);
      if (!baseId || (cta && cta.disabled)) { e.preventDefault(); return; }

      e.preventDefault();
      if (bundleSelects.length && !bundleCheck()) return;
      var nameSkipped = playerName && playerName.hasAttribute('data-optional') && !playerName.value.trim();
      var numberSkipped = playerNumber && playerNumber.hasAttribute('data-optional') && !playerNumber.value.trim();
      if (playerName && !nameSkipped && !validName(playerName.value)) {
        playerName.classList.add('is-missing');
        if (playerNameError) playerNameError.hidden = false;
        playerName.focus();
        return;
      }
      if (playerNumber && !numberSkipped && !validNumber(playerNumber.value)) {
        playerNumber.classList.add('is-missing');
        if (playerNumberError) playerNumberError.hidden = false;
        playerNumber.focus();
        return;
      }
      if (!bundleSelects.length && extraNumber && extrasNow().length && !validNumber(extraNumber.value)) {
        extraNumber.classList.add('is-missing');
        if (extraNumberError) extraNumberError.hidden = false;
        extraNumber.focus();
        return;
      }
      if (!optionalCheck()) return;
      var qty = clampQty(true);
      if (bundleSelects.length) qty = 1; // each package is its own line, counted in bundleLines

      if (cta) { cta.disabled = true; cta.textContent = 'Adding…'; }
      var items = inlineItems(baseId, qty);
      var withOptional = optionalLines();
      // One club per order: clear the cart first if it holds another club's items.
      // Not while editing: the package being changed is already in this club's cart.
      var clearIfNeeded = !editing && window.sncClubCartClear ? window.sncClubCartClear(form.dataset.club) : Promise.resolve();
      var limited = false;
      clearIfNeeded.then(function () { return withinLimit(items); }).then(function (ok) {
        if (!ok) { limited = true; return null; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items.concat(withOptional) }),
        });
      })
        .then(function (r) {
          if (limited) return null;
          if (!r.ok) throw new Error('add failed');
          if (!editing) return fetch('/cart.js');
          return r.json().catch(function () { return null; }).then(finishEdit).then(function () { return fetch('/cart.js'); });
        })
        .then(function (r) { return r ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item_count: cart.item_count } }));
          document.dispatchEvent(new CustomEvent('sannico:cart:open'));
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (cta) { cta.disabled = false; cta.textContent = addLabel; }
        });
    });
  }

  // An item with several pictures opens them in a simple viewer when its small photo is selected.
  function itemViewer() {
    var urls = [];
    var at = 0;
    var box = null;
    var img = null;
    var count = null;
    function show() {
      img.src = urls[at];
      count.textContent = (at + 1) + ' / ' + urls.length;
    }
    function close() {
      if (box) box.hidden = true;
    }
    function step(by) {
      at = (at + by + urls.length) % urls.length;
      show();
    }
    function build() {
      box = document.createElement('div');
      box.className = 'sannico-itemviewer';
      box.hidden = true;
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML =
        '<button type="button" class="sannico-itemviewer__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="sannico-itemviewer__prev" aria-label="Previous">&lsaquo;</button>' +
        '<img class="sannico-itemviewer__img" alt="">' +
        '<button type="button" class="sannico-itemviewer__next" aria-label="Next">&rsaquo;</button>' +
        '<span class="sannico-itemviewer__count"></span>';
      var st = document.createElement('style');
      st.textContent =
        '.sannico-itemviewer{position:fixed;inset:0;z-index:2147483000;background:rgba(10,14,23,.86);display:flex;align-items:center;justify-content:center}' +
        '.sannico-itemviewer[hidden]{display:none}' +
        '.sannico-itemviewer__img{max-width:86vw;max-height:84vh;object-fit:contain;background:#fff;border-radius:12px}' +
        '.sannico-itemviewer button{position:absolute;background:rgba(255,255,255,.14);color:#fff;border:0;border-radius:50%;width:44px;height:44px;font-size:28px;line-height:1;cursor:pointer}' +
        '.sannico-itemviewer__close{top:18px;right:18px}.sannico-itemviewer__prev{left:18px}.sannico-itemviewer__next{right:18px}' +
        '.sannico-itemviewer__count{position:absolute;bottom:18px;color:#fff;font:600 14px sans-serif}';
      document.head.appendChild(st);
      document.body.appendChild(box);
      img = box.querySelector('img');
      count = box.querySelector('.sannico-itemviewer__count');
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('.sannico-itemviewer__close')) close();
        else if (e.target.closest('.sannico-itemviewer__prev')) step(-1);
        else if (e.target.closest('.sannico-itemviewer__next')) step(1);
      });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });
    }
    function open(thumb) {
      urls = String(thumb.getAttribute('data-item-images') || '').split('||').filter(Boolean);
      if (!urls.length) return;
      if (!box) build();
      at = 0;
      show();
      box.hidden = false;
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-item-images]');
      if (t) open(t);
    });
    document.addEventListener('keydown', function (e) {
      var t = e.target.closest && e.target.closest('[data-item-images]');
      if (t && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        open(t);
      }
    });
  }
  itemViewer();

  function boot() { document.querySelectorAll('.sannico-pdp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.sannico-pdp');
    if (s) init(s);
  });
})();
